import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Page} from '../../model/page';
import {Company} from '../../model/company';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';

import {PagedData} from '../../model/paged-data';
import {Observable} from 'rxjs/Rx'
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import * as _ from 'lodash';
import {permissions} from '../../permissions';
import {UserService} from '../../services/user.service';
import {CompanyService} from '../../services/company.service';
import {Title} from '@angular/platform-browser';

@Component({
    templateUrl: './companies.component.html',
    providers: [
        CompanyService,
        UserService
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class CompaniesComponent implements OnInit {
    public loading = false;
    public page = new Page();
    public rows = new Array<Company>();

    private filters: { [key: string]: string; } = {};
    private permissions = permissions;

    constructor(
        private companyService: CompanyService,
        private userService: UserService,
        private toastr: ToastrService,
        private router: Router,
        private title: Title
    ) {
        this.page.pageNumber = 0;
        this.page.size = 100;
        this.title.setTitle('Admin - Companies');
    }

    createCompany() {
        this.addCompany(0);
    }

    ngOnInit() {
        this.loading = true;
        this.setPage({offset: 0});
    }

    getData() {
        this.loading = true;
        this.setPage({offset: this.page.pageNumber});
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;

        this.serverCall(this.page).subscribe(result => {
                this.page.totalElements = result.count;
                this.page.totalPages    = result.count / this.page.size;
                this.rows = result.data;
                window.dispatchEvent(new Event('resize'));
                this.loading = false;
            },
            error => {
                console.log(error);
                this.loading = false;
                window.dispatchEvent(new Event('resize'));
                this.toastr.error('Companies loading error occured', 'Service Error', {
                    timeOut: 3000,
                });
            })

    }

    public renderUser(row) {
        const users = this.userService.getAllUsers();
        let username = null;
        users.forEach(function (item) {
            if (item.US1_ID == row.CU1_CREATED_BY) {
                username = item.US1_NAME;
                return false;
            }
        });
        return username;
    }

    private getPagedData(page: Page,  count: number, companyData: Array<Company>): PagedData<Company> {
        const pagedData = new PagedData<Company>();
        pagedData.data = companyData;
        page.totalElements = count;
        page.totalPages = page.totalElements / page.size;
        pagedData.page = page;
        return pagedData;
    }

    serverCall(page: Page): Observable<any> {
        return this.companyService.getCompanies(this.page);
    }

    editCompany(row): void {
        this.router.navigate(['companies/edit/' + row.CO1_ID]);
    }

    addCompany(id): void {
        this.router.navigate(['companies/add/' + id]);
    }

    onSort(event) {
        this.page.sortParams = {};
        if (!_.isEmpty(event.sorts)) {
            for (const item of event.sorts) {
                this.page.sortParams[item.prop] = item.dir;
            }
        }
        this.ngOnInit();
    }

    onSubmit() {
        let reload = false;
        const filters = {};
        for (const key of Object.keys(this.filters)) {
            const value = this.filters[key];
            if (_.isArray(value)) {
                _.forEach(value, function (item) {
                    const data = item.name.split(':');
                    filters[data[0]] = data[1];
                });
            } else {
                if (typeof value !== 'undefined') {
                    filters[key] = value;
                }
            }
        }

        const keys = Object.keys(filters).concat(Object.keys(this.page.filterParams));
        for (const key of keys) {
            if (this.page.filterParams[key] != filters[key]) {
                reload = true;
                break;
            }
        }

        if (reload) {
            this.page.filterParams = filters;
            this.getData();
        }
    }

    onSubmitWithDelay() {
        const me = this;
        setTimeout(function() {
            me.onSubmit.call(me);
        }, 5);
    }

    accessCompany(id): void {
        this.router.navigate( ['companies/access/' + id]);
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/companies/companies.component.ts